// extracted by mini-css-extract-plugin
export var editInput = "_fk-0";
export var editInputCompact = "_fk-2";
export var editInputLarge = "_fk-1";
export var editInputSmall = "_fk-3";